import React from 'react'
import PropTypes from 'prop-types'

class LinkTd extends React.Component {
  render() {
    return(
      <td className={this.props.fieldClassName}>
        <a className='styled-link pointer-hand'
           href={this.props.fieldURL}>
          {this.props.fieldName}
        </a>
      </td>
    )
  }
}

LinkTd.propTypes = {
  fieldName: PropTypes.string,
  fieldURL: PropTypes.string,
  fieldClassName: PropTypes.string
}

export default LinkTd
